import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy, Users, DollarSign, Award, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BOARDS = [
  { key: "fans",       label: "Top Fans",           icon: Sparkles, metric_suffix: "pts" },
  { key: "buyers",     label: "Top Buyers",         icon: DollarSign, metric_prefix: "$" },
  { key: "referrers",  label: "Top Referrers",      icon: Users, metric_suffix: "refs" },
  { key: "collectors", label: "Top Collectors",     icon: Award, metric_suffix: "badges" },
  { key: "points",     label: "Top Point Earners",  icon: Trophy, metric_suffix: "pts" },
];

export default function Leaderboards() {
  const [active, setActive] = useState("fans");
  const [data, setData] = useState({ items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/leaderboards/${active}?limit=25`).then((r) => { setData(r.data); setLoading(false); });
  }, [active]);

  const currentBoard = BOARDS.find((b) => b.key === active);

  return (
    <div className="min-h-screen bg-[#050505] pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-[10px] tracking-[0.4em] text-[#D4AF37] mb-3">HALL OF FAME</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">
            Top <span className="text-[#D4AF37]">Fans</span>
          </h1>
          <p className="text-white/40 text-sm mt-3">The most loyal supporters of the movement.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {BOARDS.map((b) => (
            <button
              key={b.key}
              data-testid={`leaderboard-tab-${b.key}`}
              onClick={() => setActive(b.key)}
              className={`px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${
                active === b.key
                  ? "border-[#D4AF37] text-[#D4AF37] bg-[#D4AF37]/10"
                  : "border-white/10 text-white/50 hover:border-white/30 hover:text-white"
              }`}
            >
              <b.icon className="w-3.5 h-3.5 inline mr-2" /> {b.label}
            </button>
          ))}
        </div>

        <div className="bg-[#0A0A0A] border border-white/5 rounded-lg overflow-hidden">
          {loading ? (
            <div className="p-12 text-center text-white/40">Loading…</div>
          ) : (data.items || []).length === 0 ? (
            <div className="p-12 text-center text-white/40" data-testid="leaderboard-empty">No entries yet. Be the first to shine.</div>
          ) : (
            <div className="divide-y divide-white/5">
              {(data.items || []).map((row, idx) => (
                <div key={idx} className="flex items-center justify-between p-4 hover:bg-white/[0.02]" data-testid={`leaderboard-row-${idx}`}>
                  <div className="flex items-center gap-4">
                    <div className={`w-8 text-center font-heading text-lg ${
                      idx === 0 ? "text-[#D4AF37]" : idx === 1 ? "text-[#C0C0C0]" : idx === 2 ? "text-[#CD7F32]" : "text-white/40"
                    }`}>#{idx + 1}</div>
                    <div>
                      <div className="text-white text-sm font-medium">{row.display_name || row.username || "Anonymous"}</div>
                      <div className="text-[10px] text-white/40 uppercase tracking-widest">{row.tier_name || row.tier_slug || "explorer"}</div>
                    </div>
                  </div>
                  <div className="text-[#D4AF37] font-bold">
                    {currentBoard?.metric_prefix || ""}{typeof row.metric === "number" ? row.metric.toLocaleString() : row.metric} {currentBoard?.metric_suffix || ""}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
